import {
  Card,
  CardContent,
  Box,
  Typography,
  Button,
  Chip,
  useMediaQuery,
  Grid,
  Pagination,
  TextField,
  Fab,
  Alert,
  AlertTitle,
} from "@mui/material";
import { FormEvent, useEffect, useState } from "react";
import LayoutWithIcons from "./LayoutWithIcons";
import CommonModal from "./HWSubmitModal";
import { useCharactersContext } from "../hooks/Context";

interface Question {
  updatedBy: string;
  question: string;
  mediaUrl: string;
  difficultyLevel: string;
  answerType: number;
  active: boolean;
  marks: number;
  updatedDate: string;
  subjectId: number;
  questionBankId: number;
  classId: number;
  createdDate: string;
  createdBy: string;
  optionsList: { optionId: number; option: string; correctAnswer: string }[];
  questionPaperId: number;
  uiType: number;
  remarks: string;
}

interface LayoutProps {
  Questions: Question[];
  sectionName: string;
}

const Layout2: React.FC<LayoutProps> = ({ Questions, sectionName }) => {
  // const { selectedOptions, setSelectedOptions } = useCharactersContext();
  //console.log("BlendsQuestions:", Questions);
  const isMobile = useMediaQuery("(max-width: 600px)");
  const isTablet = useMediaQuery("(max-width:820px)");
  // const options = ["B", "A", "R", "G"];
  const [modalOpen, setModalOpen] = useState(false);
  const [isCorrectSubmission, setIsCorrectSubmission] = useState<
    boolean | null
  >(null);
  const [retryCount, setRetryCount] = useState(0);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const currentQuestion = Questions[currentQuestionIndex];

  // const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  // const [selectedOptionsArray, setSelectedOptionsArray] = useState<number[][]>(
  //   Array(Questions.length).fill([])
  // );
  // Initialize selectedOptionsArray with saved state or empty array
  // const [selectedOptionsArray, setSelectedOptionsArray] = useState<number[][]>(
  //   () => {
  //     const savedState = localStorage.getItem("selectedOptionsArrayLayout2");
  //     return savedState
  //       ? JSON.parse(savedState)
  //       : Array(Questions.length).fill([]);
  //   }
  // );
  const [selectedOptionsArray, setSelectedOptionsArray] = useState<number[][]>(
    () => {
      const storageKey = `selectedOptionsArrayLayout2_${currentQuestion.questionPaperId}`;
      const savedState = localStorage.getItem(storageKey);
      return savedState
        ? JSON.parse(savedState)
        : Array(Questions.length).fill([]);
    }
  );

  const [selectedOption, setSelectedOption] = useState("");
  const { isViewMode } = useCharactersContext();
  // const { selectedOption, setSelectedOption } = useCharactersContext();
  const handleOptionClick = (optionIndex: number) => {
    const currentSelectedOptions = [...selectedOptionsArray];
    if (currentQuestion.answerType === 3) {
      currentSelectedOptions[currentQuestionIndex] = [optionIndex];
      const selectedWord =
        sentences[1] + optionsForType3[optionIndex] + sentences[2];
      setSelectedOption(selectedWord);
    } else if (currentQuestion.answerType === 2) {
      currentSelectedOptions[currentQuestionIndex] = [optionIndex];
      const selectedWord =
        currentQuestion.optionsList[0].option + optionsForType2[optionIndex];
      setSelectedOption(selectedWord);
    } else {
      currentSelectedOptions[currentQuestionIndex] = [
        ...currentSelectedOptions[currentQuestionIndex],
        optionIndex,
      ];
      setSelectedOption("");
    }

    setSelectedOptionsArray(currentSelectedOptions);
  };

  const getSelectedLabels = () => {
    const currentSelectedOptions = selectedOptionsArray[currentQuestionIndex];
    if (currentQuestion.answerType === 3) {
      const selectedOptionIndex = currentSelectedOptions[0];
      return selectedOptionIndex !== undefined
        ? [optionsForType3[selectedOptionIndex]]
        : [];
    } else if (currentQuestion.answerType === 2) {
      const selectedOptionIndex = currentSelectedOptions[0];
      return selectedOptionIndex !== undefined
        ? [optionsForType2[selectedOptionIndex]]
        : [];
    } else if (currentQuestion.answerType === 4) {
      const selectedOptionIndex = currentSelectedOptions[0];
      return selectedOptionIndex !== undefined
        ? [optionsForType4[selectedOptionIndex]]
        : [];
    } else {
      return currentSelectedOptions.map((optionIndex) => options[optionIndex]);
    }
  };

  const handleNavigate = (direction: "previous" | "next") => {
    if (direction === "previous") {
      setCurrentQuestionIndex((prevIndex) => Math.max(prevIndex - 1, 0));
    } else if (direction === "next") {
      setCurrentQuestionIndex((prevIndex) =>
        Math.min(prevIndex + 1, Questions.length - 1)
      );
    }
  };

  const handlePaginationChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setCurrentQuestionIndex(value - 1);
  };

  const options = currentQuestion.optionsList[0].option.split("");
  const sentences = currentQuestion.question.split("<br>");

  const { questionScores, setQuestionScores, examAnswers, setExamAnswers } =
    useCharactersContext();

  const questionPaperId = currentQuestion.questionPaperId;

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setShowAlert(true);
    if (currentQuestion.answerType === 1) {
      const selectedWord = getSelectedLabels().join("");
      //console.log("Selected word", selectedWord);
      const correctAnswer =
        Questions[currentQuestionIndex].optionsList[1].option;
      const correctOptions = correctAnswer.split("");
      // useEffect(() => {
      //   // When isViewMode is true, set selectedOptions to the correctOptions
      //   if (isViewMode) {
      //     setSelectedOptionsArray(correctOptions);
      //   }
      // }, [currentQuestion]);
      if (
        selectedWord === Questions[currentQuestionIndex].optionsList[1].option
      ) {
        setIsCorrectSubmission(true);
        // playCorrectSound();
        // setModalOpen(true);
        const questionIndex = questionScores.findIndex(
          (item) => item.questionBankId === currentQuestion.questionBankId
        );

        if (questionIndex !== -1) {
          // Update the existing score
          const updatedScores = [...questionScores];
          updatedScores[questionIndex] = {
            questionBankId: currentQuestion.questionBankId,
            questionPaperId: currentQuestion.questionPaperId,
            score: currentQuestion.marks,
            layoutNumber: currentQuestion.uiType,
            sectionName: sectionName,
          };
          setQuestionScores(updatedScores);
        } else {
          // Add a new score for the question
          setQuestionScores((prevScores) => [
            ...prevScores,
            {
              questionBankId: currentQuestion.questionBankId,
              questionPaperId: currentQuestion.questionPaperId,
              score: currentQuestion.marks,
              layoutNumber: currentQuestion.uiType,
              sectionName: sectionName,
            },
          ]);
        }
      } else {
        // setIsCorrectSubmission(false);
        // playInCorrectSound();
        // setModalOpen(true);
        setQuestionScores((prevScores) => [
          ...prevScores,
          {
            questionBankId: currentQuestion.questionBankId,
            questionPaperId: currentQuestion.questionPaperId,
            score: 0,
            layoutNumber: currentQuestion.uiType,
            sectionName: sectionName,
          },
        ]);
      }
    } else if (currentQuestion.answerType === 2) {
      const selectedWord =
        currentQuestion.optionsList[0].option + getSelectedLabels();
      //console.log(selectedWord);
      const correctAnswer =
        Questions[currentQuestionIndex].optionsList[3].option;
      if (selectedWord === correctAnswer) {
        // setIsCorrectSubmission(true);
        // playCorrectSound();
        // setModalOpen(true);
        const questionIndex = questionScores.findIndex(
          (item) => item.questionBankId === currentQuestion.questionBankId
        );

        if (questionIndex !== -1) {
          // Update the existing score
          const updatedScores = [...questionScores];
          updatedScores[questionIndex] = {
            questionBankId: currentQuestion.questionBankId,
            questionPaperId: currentQuestion.questionPaperId,
            score: currentQuestion.marks,
            layoutNumber: currentQuestion.uiType,
            sectionName: sectionName,
          };
          setQuestionScores(updatedScores);
        } else {
          // Add a new score for the question
          setQuestionScores((prevScores) => [
            ...prevScores,
            {
              questionBankId: currentQuestion.questionBankId,
              questionPaperId: currentQuestion.questionPaperId,
              score: currentQuestion.marks,
              layoutNumber: currentQuestion.uiType,
              sectionName: sectionName,
            },
          ]);
        }
      } else {
        // setIsCorrectSubmission(false);
        // playInCorrectSound();
        // setModalOpen(true);
        setQuestionScores((prevScores) => [
          ...prevScores,
          {
            questionBankId: currentQuestion.questionBankId,
            questionPaperId: currentQuestion.questionPaperId,
            score: 0,
            layoutNumber: currentQuestion.uiType,
            sectionName: sectionName,
          },
        ]);
      }
    } else if (currentQuestion.answerType === 3) {
      const selectedWord = sentences[1] + getSelectedLabels() + sentences[2];
      //console.log("selectedWord", selectedWord);
      const correctAnswer =
        Questions[currentQuestionIndex].optionsList[2].option;
      //console.log("Selected word", selectedWord);
      //console.log("Correct answer", correctAnswer);
      if (
        selectedWord === Questions[currentQuestionIndex].optionsList[2].option
      ) {
        // setIsCorrectSubmission(true);
        // playCorrectSound();
        // setModalOpen(true);
        const questionIndex = questionScores.findIndex(
          (item) => item.questionBankId === currentQuestion.questionBankId
        );

        if (questionIndex !== -1) {
          // Update the existing score
          const updatedScores = [...questionScores];
          updatedScores[questionIndex] = {
            questionBankId: currentQuestion.questionBankId,
            questionPaperId: currentQuestion.questionPaperId,
            score: currentQuestion.marks,
            layoutNumber: currentQuestion.uiType,
            sectionName: sectionName,
          };
          setQuestionScores(updatedScores);
        } else {
          // Add a new score for the question
          setQuestionScores((prevScores) => [
            ...prevScores,
            {
              questionBankId: currentQuestion.questionBankId,
              questionPaperId: currentQuestion.questionPaperId,
              score: currentQuestion.marks,
              layoutNumber: currentQuestion.uiType,
              sectionName: sectionName,
            },
          ]);
        }
      } else {
        // setIsCorrectSubmission(false);
        // playInCorrectSound();
        // setModalOpen(true);
        setQuestionScores((prevScores) => [
          ...prevScores,
          {
            questionBankId: currentQuestion.questionBankId,
            questionPaperId: currentQuestion.questionPaperId,
            score: 0,
            layoutNumber: currentQuestion.uiType,
            sectionName: sectionName,
          },
        ]);
      }
    } else if (currentQuestion.answerType === 4) {
      const selectedWord =
        getSelectedLabels() + currentQuestion.optionsList[2].option;
      console.log(selectedWord);
      const correctAnswer =
        Questions[currentQuestionIndex].optionsList[3].option;
      if (selectedWord === correctAnswer) {
        // setIsCorrectSubmission(true);
        // playCorrectSound();
        // setModalOpen(true);
        //console.log("correct answer");
        const questionIndex = questionScores.findIndex(
          (item) => item.questionBankId === currentQuestion.questionBankId
        );

        if (questionIndex !== -1) {
          // Update the existing score
          const updatedScores = [...questionScores];
          updatedScores[questionIndex] = {
            questionBankId: currentQuestion.questionBankId,
            questionPaperId: currentQuestion.questionPaperId,
            score: currentQuestion.marks,
            layoutNumber: currentQuestion.uiType,
            sectionName: sectionName,
          };
          setQuestionScores(updatedScores);
        } else {
          // Add a new score for the question
          setQuestionScores((prevScores) => [
            ...prevScores,
            {
              questionBankId: currentQuestion.questionBankId,
              questionPaperId: currentQuestion.questionPaperId,
              score: currentQuestion.marks,
              layoutNumber: currentQuestion.uiType,
              sectionName: sectionName,
            },
          ]);
        }
      } else {
        // setIsCorrectSubmission(false);
        // playInCorrectSound();
        // setModalOpen(true);
        setQuestionScores((prevScores) => [
          ...prevScores,
          {
            questionBankId: currentQuestion.questionBankId,
            questionPaperId: currentQuestion.questionPaperId,
            score: 0,
            layoutNumber: currentQuestion.uiType,
            sectionName: sectionName,
          },
        ]);
      }
    }

    // const currentSelectedOptions = [...selectedOptionsArray];
    // currentSelectedOptions[currentQuestionIndex] = [];
    // setSelectedOptionsArray(currentSelectedOptions);

    //exam ans logic started
    if (currentQuestion.answerType === 1) {
      const selectedWord = getSelectedLabels().join("");
      // console.log("Selected word", selectedWord);
      const correctAnswer =
        Questions[currentQuestionIndex].optionsList[1].option;
      const correctOptions = correctAnswer.split("");

      const updatedExamAnswer = {
        questionBankId: currentQuestion.questionBankId,
        acutalOptionValue: correctOptions.join(""),
        enteredOptionValue: selectedWord,
      };

      // Reset selectedOptions for the next question
      setSelectedOption("");

      // Check if there is already an answer for the current question
      const existingAnswerIndex = examAnswers.findIndex(
        (answer) => answer.questionBankId === currentQuestion.questionBankId
      );

      if (existingAnswerIndex !== -1) {
        // If an answer already exists, update the existing one
        setExamAnswers((prevAnswers) =>
          prevAnswers.map((answer, index) =>
            index === existingAnswerIndex ? { ...updatedExamAnswer } : answer
          )
        );
      } else {
        // If there is no existing answer, add the new answer
        setExamAnswers((prevAnswers) => [...prevAnswers, updatedExamAnswer]);
      }
    } else if (currentQuestion.answerType === 2) {
      const selectedWord =
        currentQuestion.optionsList[0].option + getSelectedLabels();
      // console.log(selectedWord);
      const correctAnswer =
        Questions[currentQuestionIndex].optionsList[3].option;
      const correctOptions = correctAnswer.split("");

      const updatedExamAnswer = {
        questionBankId: currentQuestion.questionBankId,
        acutalOptionValue: correctOptions.join(""),
        enteredOptionValue: selectedWord,
      };

      // Reset selectedOptions for the next question
      setSelectedOption("");

      // Check if there is already an answer for the current question
      const existingAnswerIndex = examAnswers.findIndex(
        (answer) => answer.questionBankId === currentQuestion.questionBankId
      );

      if (existingAnswerIndex !== -1) {
        // If an answer already exists, update the existing one
        setExamAnswers((prevAnswers) =>
          prevAnswers.map((answer, index) =>
            index === existingAnswerIndex ? { ...updatedExamAnswer } : answer
          )
        );
      } else {
        // If there is no existing answer, add the new answer
        setExamAnswers((prevAnswers) => [...prevAnswers, updatedExamAnswer]);
      }
    } else if (currentQuestion.answerType === 3) {
      const selectedWord = sentences[1] + getSelectedLabels() + sentences[2];
      //console.log("selectedWord", selectedWord);
      const correctAnswer =
        Questions[currentQuestionIndex].optionsList[2].option;
      // console.log("Selected word", selectedWord);
      //console.log("Correct answer", correctAnswer);

      const correctOptions = correctAnswer.split("");
      const updatedExamAnswer = {
        questionBankId: currentQuestion.questionBankId,
        acutalOptionValue: correctOptions.join(""),
        enteredOptionValue: selectedWord,
      };

      // Reset selectedOptions for the next question
      setSelectedOption("");

      // Check if there is already an answer for the current question
      const existingAnswerIndex = examAnswers.findIndex(
        (answer) => answer.questionBankId === currentQuestion.questionBankId
      );

      if (existingAnswerIndex !== -1) {
        // If an answer already exists, update the existing one
        setExamAnswers((prevAnswers) =>
          prevAnswers.map((answer, index) =>
            index === existingAnswerIndex ? { ...updatedExamAnswer } : answer
          )
        );
      } else {
        // If there is no existing answer, add the new answer
        setExamAnswers((prevAnswers) => [...prevAnswers, updatedExamAnswer]);
      }
    } else if (currentQuestion.answerType === 4) {
      const selectedWord =
        getSelectedLabels() + currentQuestion.optionsList[2].option;
      // console.log(selectedWord);
      const correctAnswer =
        Questions[currentQuestionIndex].optionsList[3].option;
      const correctOptions = correctAnswer.split("");
      const updatedExamAnswer = {
        questionBankId: currentQuestion.questionBankId,
        acutalOptionValue: correctOptions.join(""),
        enteredOptionValue: selectedWord,
      };

      // Reset selectedOptions for the next question
      setSelectedOption("");

      // Check if there is already an answer for the current question
      const existingAnswerIndex = examAnswers.findIndex(
        (answer) => answer.questionBankId === currentQuestion.questionBankId
      );

      if (existingAnswerIndex !== -1) {
        // If an answer already exists, update the existing one
        setExamAnswers((prevAnswers) =>
          prevAnswers.map((answer, index) =>
            index === existingAnswerIndex ? { ...updatedExamAnswer } : answer
          )
        );
      } else {
        // If there is no existing answer, add the new answer
        setExamAnswers((prevAnswers) => [...prevAnswers, updatedExamAnswer]);
      }
    }

    //ended
  };

  const optionsListForType3 = currentQuestion.optionsList.slice(0, 2);
  const optionsForType3 = optionsListForType3.map(
    (optionObj) => optionObj.option
  );

  const optionListForType2 = currentQuestion.optionsList.slice(1, 3);
  const optionsForType2 = optionListForType2.map(
    (optionObj) => optionObj.option
  );

  const optionListForType4 = currentQuestion.optionsList.slice(0, 2);
  const optionsForType4 = optionListForType4.map(
    (optionObj) => optionObj.option
  );

  useEffect(() => {
    if (isViewMode) {
      if (currentQuestion.answerType === 1) {
        const correctOptionsArray = Questions.map((question, index) => {
          const correctAnswer = question.optionsList[1].option;
          const correctIndices = [];

          for (let i = 0; i < correctAnswer.length; i++) {
            const correctChar = correctAnswer[i];
            const optionIndex =
              question.optionsList[0].option.indexOf(correctChar);
            if (optionIndex !== -1) {
              correctIndices.push(optionIndex);
            }
          }

          return correctIndices;
        });

        setSelectedOptionsArray(correctOptionsArray);
      } else if (currentQuestion.answerType === 2) {
        const optionsOfType2 = currentQuestion.optionsList.slice(1, 3);
        const correctIndexOfType2 = optionsOfType2.findIndex(
          (option) => option.correctAnswer
        );

        if (correctIndexOfType2 !== -1) {
          const correctIndexesArray = Array(Questions.length).fill([]);
          correctIndexesArray[currentQuestionIndex] = [correctIndexOfType2];
          setSelectedOptionsArray(correctIndexesArray);
        }
      } else if (currentQuestion.answerType === 3) {
        const optionsOfType3 = currentQuestion.optionsList.slice(0, 2);
        const correctIndexOfType3 = optionsOfType3.findIndex(
          (option) => option.correctAnswer
        );

        if (correctIndexOfType3 !== -1) {
          const correctIndexesArray = Array(Questions.length).fill([]);
          correctIndexesArray[currentQuestionIndex] = [correctIndexOfType3];
          setSelectedOptionsArray(correctIndexesArray);
        }
      } else if (currentQuestion.answerType === 4) {
        const optionsOfType4 = currentQuestion.optionsList.slice(0, 2);
        const correctIndexOfType4 = optionsOfType4.findIndex(
          (option) => option.correctAnswer
        );

        if (correctIndexOfType4 !== -1) {
          const correctIndexesArray = Array(Questions.length).fill([]);
          correctIndexesArray[currentQuestionIndex] = [correctIndexOfType4];
          setSelectedOptionsArray(correctIndexesArray);
        }
      }
    }
  }, [isViewMode, currentQuestion]);

  const playCorrectSound = () => {
    const correctSound = new Audio(
      require("../assets/correct-choice-43861.mp3")
    );
    correctSound.play();
    handleOpen();
  };

  const playInCorrectSound = () => {
    const incorrectSound = new Audio(
      require("../assets/wronganswer-37702.mp3")
    );
    incorrectSound.play();
    handleOpen();
  };

  const handleOpen = () => setModalOpen(true);
  const handleClose = () => setModalOpen(false);

  const handleContinue = () => {
    setCurrentQuestionIndex((prevIndex) =>
      Math.min(prevIndex + 1, Questions.length - 1)
    );
    setModalOpen(false);
  };

  // const handleRetry = () => {
  //   const currentSelectedOptions = [...selectedOptionsArray];
  //   currentSelectedOptions[currentQuestionIndex] = [];
  //   setSelectedOptionsArray(currentSelectedOptions);
  //   setModalOpen(false);
  // };
  const handleRetry = () => {
    const currentSelectedOptions = [...selectedOptionsArray];
    currentSelectedOptions[currentQuestionIndex] = [];
    setSelectedOptionsArray(currentSelectedOptions);
    setModalOpen(false);

    if (retryCount < 1) {
      setRetryCount(retryCount + 1);
    } else {
      setCurrentQuestionIndex((prevIndex) =>
        Math.min(prevIndex + 1, Questions.length - 1)
      );
      setRetryCount(0);
    }
  };

  // useEffect(() => {
  //   localStorage.setItem(
  //     "selectedOptionsArrayLayout2",
  //     JSON.stringify(selectedOptionsArray)
  //   );
  // }, [selectedOptionsArray]);
  useEffect(() => {
    const storageKey = `selectedOptionsArrayLayout2_${currentQuestion.questionPaperId}`;
    localStorage.setItem(storageKey, JSON.stringify(selectedOptionsArray));
  }, [
    selectedOptionsArray,
    currentQuestion.answerType,
    currentQuestion.questionPaperId,
  ]);

  const renderUIBasedOnAnswerType = () => {
    switch (currentQuestion.answerType) {
      case 1:
        return (
          <>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "row",
                mt: 2,
                flexWrap: "wrap",
                gap: "8px",
              }}
            >
              {options.map((option, index) => (
                <Button
                  key={index}
                  onClick={() => handleOptionClick(index)}
                  disabled={selectedOptionsArray[currentQuestionIndex].includes(
                    index
                  )}
                  variant="contained"
                  sx={{
                    borderRadius: "50px",
                    minWidth: "40px",
                    minHeight: "40px",
                    m: 1,
                    color: "white",
                    ...(isMobile && {
                      fontSize: "12px",
                      padding: "0.5vh 0.5vh",
                      minWidth: "4.5vh",
                      minHeight: "4.5vh",
                    }),
                    "&.Mui-disabled": {
                      backgroundColor: "red",
                      color: "white",
                    },
                  }}
                >
                  {option}
                </Button>
              ))}
            </Box>
            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
              {selectedOptionsArray[currentQuestionIndex].length > 0 && (
                <Chip
                  label={getSelectedLabels().join("")}
                  onDelete={() => {
                    const currentSelectedOptions = [...selectedOptionsArray];
                    currentSelectedOptions[currentQuestionIndex] = [];
                    setSelectedOptionsArray(currentSelectedOptions);
                  }}
                  size="medium"
                  sx={{
                    height: "40px",
                    width: "auto",
                    marginRight: "5px",
                    marginTop: "2px",
                    "& .MuiChip-label": {
                      fontWeight: "bold",
                      fontSize: "15px",
                    },
                  }}
                />
              )}
            </Box>
          </>
        );
      case 2:
        const selectedOptionIndex2 =
          selectedOptionsArray[currentQuestionIndex][0];
        const selectedOption2 =
          selectedOptionIndex2 !== undefined
            ? optionsForType2[selectedOptionIndex2]
            : "";
        return (
          <>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "row",
                mt: 0,
                flexWrap: "wrap",
                gap: "8px",
              }}
            >
              <Fab
                sx={{
                  borderRadius: "50px",
                  minWidth: "40px",
                  minHeight: "40px",
                  m: 1,
                  color: "white",
                  backgroundColor: "red !important",
                  ...(isMobile && {
                    fontSize: "12px",
                    padding: "0.5vh 0.5vh",
                    minWidth: "4.5vh",
                    minHeight: "4.5vh",
                  }),
                }}
              >
                {currentQuestion.optionsList[0].option}
              </Fab>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  mt: 1.5,
                  flexWrap: "wrap",
                  gap: "5px",
                }}
              >
                {optionsForType2.map((option, index) => (
                  <Button
                    key={index}
                    onClick={() => handleOptionClick(index)}
                    disabled={selectedOptionsArray[
                      currentQuestionIndex
                    ].includes(index)}
                    variant="contained"
                    sx={{
                      borderRadius: "50px",
                      minWidth: "40px",
                      minHeight: "40px",
                      m: 1,
                      color: "white",
                      ...(isMobile && {
                        fontSize: "12px",
                        padding: "0.5vh 0.5vh",
                        minWidth: "4.5vh",
                        minHeight: "4.5vh",
                      }),
                      "&.Mui-disabled": {
                        backgroundColor: "red",
                        color: "white",
                      },
                    }}
                  >
                    {option}
                  </Button>
                ))}
              </Box>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
              {selectedOptionsArray[currentQuestionIndex].length > 0 && (
                <Chip
                  label={
                    currentQuestion.optionsList[0].option + selectedOption2
                  }
                  onDelete={() => {
                    const currentSelectedOptions = [...selectedOptionsArray];
                    currentSelectedOptions[currentQuestionIndex] = [];
                    setSelectedOptionsArray(currentSelectedOptions);
                    setSelectedOption("");
                  }}
                  size="medium"
                  sx={{
                    height: "40px",
                    width: "auto",
                    marginRight: "5px",
                    marginTop: "2px",
                    "& .MuiChip-label": {
                      fontWeight: "bold",
                      fontSize: "15px",
                    },
                  }}
                />
              )}
            </Box>
          </>
        );
      case 3:
        const selectedOptionIndex =
          selectedOptionsArray[currentQuestionIndex][0];
        const selectedOption =
          selectedOptionIndex !== undefined
            ? optionsForType3[selectedOptionIndex]
            : "";

        return (
          <>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "row",
                mt: 2,
                flexWrap: "wrap",
                gap: "8px",
              }}
            >
              {optionsForType3.map((option, index) => (
                <Button
                  key={index}
                  onClick={() => handleOptionClick(index)}
                  disabled={selectedOptionsArray[currentQuestionIndex].includes(
                    index
                  )}
                  variant="contained"
                  sx={{
                    borderRadius: "50px",
                    minWidth: "40px",
                    minHeight: "40px",
                    m: 1,
                    color: "white",
                    ...(isMobile && {
                      fontSize: "12px",
                      padding: "0.5vh 0.5vh",
                      minWidth: "4.5vh",
                      minHeight: "4.5vh",
                    }),
                    "&.Mui-disabled": {
                      backgroundColor: "red",
                      color: "white",
                    },
                  }}
                >
                  {option}
                </Button>
              ))}
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "row",
              }}
            >
              <Typography sx={{ mt: isMobile ? "12px" : "10px" }}>
                {sentences[1]}
              </Typography>
              <TextField
                value={selectedOption}
                variant="standard"
                sx={{
                  width: "30px",
                }}
                InputProps={{ readOnly: true }}
              />
              <Typography sx={{ mt: isMobile ? "12px" : "10px" }}>
                {sentences[2]}
              </Typography>
            </Box>
          </>
        );
      case 4:
        const selectedOptionIndex4 =
          selectedOptionsArray[currentQuestionIndex][0];
        const selectedOption4 =
          selectedOptionIndex4 !== undefined
            ? optionsForType4[selectedOptionIndex4]
            : "";
        return (
          <>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "row",
                mt: 0,
                flexWrap: "wrap",
                gap: "8px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  mt: 1.5,
                  flexWrap: "wrap",
                  gap: "5px",
                }}
              >
                {optionsForType4.map((option, index) => (
                  <Button
                    key={index}
                    onClick={() => handleOptionClick(index)}
                    disabled={selectedOptionsArray[
                      currentQuestionIndex
                    ].includes(index)}
                    variant="contained"
                    sx={{
                      borderRadius: "50px",
                      minWidth: "40px",
                      minHeight: "40px",
                      m: 1,
                      color: "white",
                      ...(isMobile && {
                        fontSize: "12px",
                        padding: "0.5vh 0.5vh",
                        minWidth: "4.5vh",
                        minHeight: "4.5vh",
                      }),
                      "&.Mui-disabled": {
                        backgroundColor: "red",
                        color: "white",
                      },
                    }}
                  >
                    {option}
                  </Button>
                ))}
              </Box>
              <Fab
                sx={{
                  borderRadius: "50px",
                  minWidth: "40px",
                  minHeight: "40px",
                  m: 1,
                  color: "white",
                  backgroundColor: "red !important",
                  ...(isMobile && {
                    fontSize: "12px",
                    padding: "0.5vh 0.5vh",
                    minWidth: "4.5vh",
                    minHeight: "4.5vh",
                  }),
                }}
              >
                {currentQuestion.optionsList[2].option}
              </Fab>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
              {selectedOptionsArray[currentQuestionIndex].length > 0 && (
                <Chip
                  label={
                    selectedOption4 + currentQuestion.optionsList[2].option
                  }
                  onDelete={() => {
                    const currentSelectedOptions = [...selectedOptionsArray];
                    currentSelectedOptions[currentQuestionIndex] = [];
                    setSelectedOptionsArray(currentSelectedOptions);
                    setSelectedOption("");
                  }}
                  size="medium"
                  sx={{
                    height: "40px",
                    width: "auto",
                    marginRight: "5px",
                    marginTop: "2px",
                    "& .MuiChip-label": {
                      fontWeight: "bold",
                      fontSize: "15px",
                    },
                  }}
                />
              )}
            </Box>
          </>
        );
    }
  };
  const [showAlert, setShowAlert] = useState(false);
  const handleAlertClose = () => setShowAlert(false);
  setTimeout(handleAlertClose, 3000);

  //started

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "auto",
        // marginTop: isViewMode ? "3%" : "auto",
        marginTop:
          (isMobile || isTablet) && isViewMode
            ? "8%"
            : isMobile
            ? "10%"
            : isTablet
            ? "20%"
            : isViewMode
            ? "3%"
            : "auto",
      }}
    >
      {/* <CommonModal
        open={modalOpen}
        isCorrectSubmission={isCorrectSubmission}
        handleContinue={handleContinue}
        handleRetry={handleRetry}
        handleClose={handleClose}
      /> */}
      {showAlert && (
        <Alert
          severity="success"
          variant="filled"
          sx={{
            position: "fixed",
            top: "30%",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 9999,
            padding: "0.5",
          }}
        >
          <AlertTitle sx={{ color: "white" }}>Answer submitted</AlertTitle>
        </Alert>
      )}
      <LayoutWithIcons onNavigate={handleNavigate}>
        {currentQuestion && (
          <Card
            variant="outlined"
            sx={{
              borderRadius: "12px",
              boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
              pointerEvents: isViewMode ? "none" : "auto",
            }}
          >
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  paddingBottom: "0px",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "700",
                    fontSize: isMobile ? "100%" : "110%",
                  }}
                >
                  {sentences[0]}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  mt: 2,
                }}
              >
                <img
                  src={currentQuestion.mediaUrl}
                  alt="questionImg"
                  width="100"
                  height="100"
                />
              </Box>
              {renderUIBasedOnAnswerType()}
              <form onSubmit={handleSubmit}>
                {!isViewMode && (
                  <Box
                    sx={{ display: "flex", justifyContent: "center", mt: 2 }}
                  >
                    <Button
                      type="submit"
                      variant="contained"
                      disabled={
                        selectedOptionsArray[currentQuestionIndex].length < 1
                      }
                    >
                      Submit
                    </Button>
                    {currentQuestion.answerType === 3 && (
                      <>
                        <Button
                          type="submit"
                          variant="outlined"
                          onClick={() => {
                            const currentSelectedOptions = [
                              ...selectedOptionsArray,
                            ];
                            currentSelectedOptions[currentQuestionIndex] = [];
                            setSelectedOptionsArray(currentSelectedOptions);
                          }}
                        >
                          Reset
                        </Button>
                      </>
                    )}
                    {currentQuestion.answerType === 2 && (
                      <>
                        <Button
                          type="submit"
                          variant="outlined"
                          onClick={() => {
                            const currentSelectedOptions = [
                              ...selectedOptionsArray,
                            ];
                            currentSelectedOptions[currentQuestionIndex] = [];
                            setSelectedOptionsArray(currentSelectedOptions);
                          }}
                        >
                          Reset
                        </Button>
                      </>
                    )}
                  </Box>
                )}
              </form>
            </CardContent>
          </Card>
        )}
        <Grid container lg={12} md={12} sm={12} xs={12} justifyContent="center">
          <Pagination
            count={Questions.length}
            shape="rounded"
            sx={{
              marginBottom: "1vh",
              paddingTop: "4%",
            }}
            page={currentQuestionIndex + 1}
            onChange={handlePaginationChange}
          />
        </Grid>
      </LayoutWithIcons>
    </div>
  );
};

export default Layout2;
